<template lang="pug">
.druck-vorlage__page(@click="clickPage" @mousedown="mouseDownPage" :style="{ width: `${value.width}mm`, height: `${value.height}mm`, backgroundImage: backgroundUrl }")
  slot(name="page-pre" v-bind="{ page: value }")
  template(v-for="text in value.texts")
    .druck-vorlage__page__text(@click="clickText($event, text)" :class="classFor(text)" :style="`left: ${text.x}mm; top: ${text.y}mm; width: ${text.width}mm; height: ${text.height}mm; font-size: ${text.size}mm; line-height: ${text.lineHeight}`")
      slot(name="text-pre" v-bind="{ text }")
      slot(name="text" v-bind="{ text }")
        div(v-html="text.text")

</template>

<script>
export default {
  props: {
    value: Object,
    bg: Boolean,
  },
  components: {
  },
  data() {
    return {
    }
  },
  computed: {
    backgroundUrl() {
      if (this.bg && this.value.backgroundUrl) {
        return `url(${this.value.backgroundUrl})`
      } else {
        return null
      }
    }
  },
  methods: {
    classFor(text) {
      return text.options.join(' ')
    },
    clickPage(event) {
      const page = this.value
      const rect = this.$el.getBoundingClientRect()
      const xPx = event.clientX - rect.x
      const yPx = event.clientY - rect.y
      const pos = {
        x: xPx / rect.width * page.width,
        y: yPx / rect.height * page.height,
        xPx,
        yPx,
        event,
      }
      this.$emit('click-page', pos, page)
    },
    clickText(event, text) {
      this.$emit('click-text', event, this.value, text)
    },
    mouseDownPage(event) {
      // console.log(event)
    },
    mouseUpPage(event) {
      console.log(event)
    },
    mouseMovePage(event) {
      console.log(event)
    },
  },
}
</script>
